import { DummyStore } from 'stores';

const availableLocalesStore = new DummyStore<availableLocales[]>([]);

export { availableLocalesStore };
